import {Component} from "@angular/core";
import {ViewController, Events} from "ionic-angular";
import {OrganisationService} from "../../../pages/signup/interpreter-signup/organisation.service";

@Component({
  templateUrl: 'organisation-search-modal.component.html',
})
export class OrganisationSearchModal{
  organisations: any[];

  constructor(private viewCtrl: ViewController,
              private events: Events,
              private organisationService: OrganisationService
  ) {
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  selectOrganisation(org){
    this.events.publish('organisation:selected', org);
    this.dismiss();
  }

  getOrganisations(ev: any){
    let val = ev.target.value;
    if(!val || val.trim() === ''){
      return;
    }

    this.organisationService.searchOrganisations(val)
      .subscribe(orgs => {
        this.organisations = orgs;
        if(!orgs.find((org) => org.name.toLowerCase().trim() === val.toLowerCase().trim())){
          this.organisations.push(val);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/organisation-search-modal/organisation-search-modal.component.ts